import { AxiosInstance } from 'axios';
import {
  VendorContactEndpoints,
  SearchVendorContactsRequest,
  SearchVendorContactsResponse,
  CreateVendorContactRequest,
  CreateVendorContactResponse,
  DeleteVendorContactRequest,
  DeleteVendorContactResponse,
  UpdateVendorContactRequest,
  UpdateVendorContactResponse,
  InviteVendorContactRequest,
  InviteVendorContactResponse,
  VendorContactDetailsRequest,
  VendorContactDetailsResponse,
} from './VendorContactServices.types';

export class VendorContactServices implements VendorContactEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchVendorContactsRequest) {
    return this.instance.get<SearchVendorContactsResponse>(
      `/vendors/${request.routeParams.accountId}/contacts`,
      {
        params: request.queryParams,
      },
    );
  }

  getById(request: VendorContactDetailsRequest) {
    return this.instance.get<VendorContactDetailsResponse>(
      `/vendors/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}`,
    );
  }

  create(request: CreateVendorContactRequest) {
    return this.instance.post<CreateVendorContactResponse>(
      `/vendors/${request.routeParams.accountId}/contacts`,
      request.body,
    );
  }

  update(request: UpdateVendorContactRequest) {
    return this.instance.put<UpdateVendorContactResponse>(
      `/vendors/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}`,
      request.body,
    );
  }

  delete(request: DeleteVendorContactRequest) {
    return this.instance.delete<DeleteVendorContactResponse>(
      `/vendors/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}`,
    );
  }

  invite(request: InviteVendorContactRequest) {
    return this.instance.put<InviteVendorContactResponse>(
      `/vendors/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}/invite`,
      request.body,
    );
  }
}
